import React, { useEffect } from "react";

const OtpPopup = ({
  visible,
  onClose,
  phoneNumber,
  onEditPhone,
  sendOTP,
  otpRequested,
  verified,
  showOtpField,
  countdown,
  otpInvalidFormat,
  otpNumericIncorrect,
  handleOtpChange,
  handleOtpBackspace,
}) => {
  if (!visible) return null;

  useEffect(() => {
    if (verified) {
      onClose();
    }
  }, [verified, onClose]);

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center sm:p-2">
      <div className="bg-white rounded-xl px-6 py-12  sm:px-2 w-full max-w-xl text-center relative">
        <h2 className="text-3xl font-semibold mb-1">OTP Verification</h2>
        <p className="text-gray-600 text-base2 font-medium mb-4 sm:text-base">
          Enter the code from the SMS sent to{" "}
          <span
            className="text-[#086AC9] font-medium cursor-pointer flex justify-center ml-xsp"
            onClick={onEditPhone}
          >
            +91 {phoneNumber} 
            <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#086AC9"><path d="M5 18.89H6.41421L15.7279 9.57627L14.3137 8.16206L5 17.4758V18.89ZM21 20.89H3V16.6473L16.435 3.21231C16.8256 2.82179 17.4587 2.82179 17.8492 3.21231L20.6777 6.04074C21.0682 6.43126 21.0682 7.06443 20.6777 7.45495L9.24264 18.89H21V20.89ZM15.7279 6.74785L17.1421 8.16206L18.5563 6.74785L17.1421 5.33363L15.7279 6.74785Z"></path></svg>
          </span>
        </p>

        {showOtpField && (
          <>
            <div className="flex justify-between mt-2 gap-2">
              {[...Array(6)].map((_, index) => (
                <input
                  key={index}
                  id={`digit${index + 1}`}
                  type="text"
                  maxLength={1}
                  pattern="[0-9]"
                  className="h-6 px-1 text-xs text-center rounded-md border border-[#aaa] w-[65px] sm:w-9"
                  onChange={(e) => handleOtpChange(e, index)}
                  onKeyDown={(e) => handleOtpBackspace(e, index)}
                />
              ))}
            </div>

            {otpInvalidFormat && (
              <p className="text-progressColor4 text-sm mt-1">
                Please enter correct OTP
              </p>
            )}
            {otpNumericIncorrect && (
              <p className="text-progressColor4 text-sm mt-1">
                Incorrect OTP
              </p>
            )}
          </>
        )}

        {otpRequested && !verified && (
          <div className="flex items-center justify-center text-base2 mt-4 font-medium gap-0.5">
            Didn’t receive the OTP
            {countdown > 0 ? (
              <span className="text-[#086AC9] ml-xsp">
                Resend in {countdown}s
              </span>
            ) : (
              <button
                type="button"
                onClick={sendOTP}
                className="text-[#086AC9] ml-xsp underline cursor-pointer"
              >
                RESEND
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OtpPopup;
